/* istanbul ignore file */
import React from 'react';
import { EmployeeInput } from 'domain/shared/employee';
import { TextInput } from 'framework/form';
import { useFieldHelper } from 'framework/ui/field';

interface TicketAssigneeSearchFieldProps {
  sourceAlias: string;
  nameSource: string;
  projectName: string;
  label: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  showInput?: boolean;
  errors?: string[];
}

const TicketAssigneeSearchField = ({
  sourceAlias,
  nameSource,
  isDisabled = false,
  showInput = true,
  projectName,
  ...props
}: TicketAssigneeSearchFieldProps) => {
  const { getValue } = useFieldHelper({ nameSource });
  const employeeName = getValue();

  return (
    <>
      {showInput ? (
        <EmployeeInput
          mapResults={(employee: any) => ({
            id: employee.alias,
            text: `${employee.nameEn.firstName} ${employee.nameEn.lastName}`,
          })}
          source={sourceAlias}
          nameSource={nameSource}
          disabled={isDisabled}
          defaultFilter={{
            'specification:memberOfProject': { in: [projectName] },
          }}
          {...props}
        />
      ) : (
        <TextInput source={sourceAlias} value={employeeName} isRequired disabled {...props} />
      )}
    </>
  );
};

export default TicketAssigneeSearchField;
